export default __webpack_public_path__ + "static/media/us-tn.553bd156.svg";